import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../common/components';
import { HiddenMobile } from '../../../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { DesktopTopHeaderBarSkeleton } from '../../../layouts/LayoutWithLeftDesktopNav/DesktopTopHeaderBar/DesktopTopHeaderBarSkeleton';
import { DesktopLeftNavSkeleton } from '../../../layouts/LayoutWithLeftDesktopNav/DesktopLeftNav/DesktopLeftNavSkeleton';
import { HiddenDesktop } from '../../../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenDesktop/HiddenDesktop';

export const SavingsPlanNavigationBarSkeleton = () => (
  <div
    data-testid="savings-plan-details-navigation-bar-skeleton"
    className={css({ display: 'flex', gap: 'medium', paddingX: 'medium' })}
  >
    <SkeletonElement width="24px" height="24px" borderRadius="30px" />
    <div
      className={css({
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginInlineEnd: 'extra_large',
      })}
    >
      <SkeletonElement width="120px" height="22px" borderRadius="30px" />
    </div>
  </div>
);

export const SavingsPlanHeaderSkeleton = () => (
  <div
    data-testid="savings-plan-details-header-skeleton"
    className={css({
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      px: 'large',
    })}
  >
    <SkeletonElement width="60%" height="30px" borderRadius="30px" />

    <SkeletonElement width="30px" height="30px" borderRadius="50%" />
  </div>
);

export const SavingsPlanAssetInfoSkeleton = () => (
  <div
    data-testid="savings-plan-asset-details-skeleton"
    className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: 'medium',
      width: '100%',
    })}
  >
    <div
      className={css({
        display: 'flex',
        gap: 'extra_small_2',
      })}
    >
      <SkeletonElement width="20px" height="20px" borderRadius="50%" />

      <SkeletonElement width="50%" height="20px" borderRadius="30px" />
    </div>

    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'medium',
        width: '100%',
      })}
    >
      <SkeletonElement width="30%" height="46px" borderRadius="30px" />
      <SkeletonElement width="50%" height="20px" borderRadius="30px" />
    </div>
  </div>
);

export const SavingsPlanDetailsFieldSkeleton = () => (
  <div
    className={css({
      display: 'flex',
      textAlign: 'start',
      gap: 'extra_small_2',
    })}
    data-testid="savings-plan-details-field-skeleton"
  >
    <SkeletonElement width="110px" height="20px" borderRadius="30px" />
    <SkeletonElement width="40px" height="20px" borderRadius="30px" />
  </div>
);

export const SavingsPlansDetailsContentSkeleton = () => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: 'extra_large',
      paddingX: 'medium',
    })}
    data-testid="savings-plan-details-content-skeleton"
  >
    <SavingsPlanHeaderSkeleton />
    <SavingsPlanAssetInfoSkeleton />

    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
      })}
    >
      <SavingsPlanDetailsFieldSkeleton />
      <SavingsPlanDetailsFieldSkeleton />
    </div>
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
      })}
    >
      <SavingsPlanDetailsFieldSkeleton />
      <SavingsPlanDetailsFieldSkeleton />
      <SavingsPlanDetailsFieldSkeleton />
      <SavingsPlanDetailsFieldSkeleton />
    </div>
  </div>
);

export const SavingsPlanDetailsSkeleton = () => (
  <div
    className={css({
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: { base: undefined, lg: 'neutrals.card_fill_primary' },
      insetInline: {
        base: undefined,
        lg: '75px',
      },
      paddingTop: {
        base: undefined,
        lg: '75px',
      },
      height: '100vh',
      overflow: 'hidden',
    })}
  >
    <HiddenMobile>
      <DesktopTopHeaderBarSkeleton />
    </HiddenMobile>

    <HiddenMobile>
      <DesktopLeftNavSkeleton />
    </HiddenMobile>
    <main
      className={css({
        display: 'flex',
        flex: 'auto',
        flexDirection: 'column',
        paddingBottom: 0,
        marginX: 'auto',
        width: {
          base: '100%',
          lg: '1440px',
        },
        maxWidth: '100%',
      })}
    >
      <div
        data-testid="savings-plan-details-skeleton"
        className={css({
          display: 'flex',
          flexDirection: 'column',
          paddingTop: 'small',
          gap: 'large',
        })}
      >
        <HiddenDesktop>
          <SavingsPlanNavigationBarSkeleton />
        </HiddenDesktop>

        <SavingsPlansDetailsContentSkeleton />
      </div>
    </main>
  </div>
);
